module.exports = __webpack_public_path__ + "img/image01.2993a78f.jpg";